import { render, staticRenderFns } from "./region_dividend_list.vue?vue&type=template&id=08e52f4c"
import script from "./region_dividend_list.vue?vue&type=script&lang=js"
export * from "./region_dividend_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports